/**
 * Games won on this browser: a bare count, kept only on this device. No name, no room,
 * nothing about who it belongs to — it is never sent anywhere. Ben's call, 1 October 2026.
 */

import type { GameEvent, PlayerId } from '@garbage/shared';

const WINS_KEY = 'garbage.wins';

export function loadWins(): number {
  try {
    const saved = Number(localStorage.getItem(WINS_KEY));
    return Number.isInteger(saved) && saved > 0 ? saved : 0;
  } catch {
    return 0;
  }
}

/** Count a win if these events say this player has just won the match. Returns the total. */
export function countWin(events: readonly GameEvent[], you: PlayerId): number {
  const won = events.some((e) => e.type === 'MATCH_WON' && e.playerId === you);
  if (!won) return loadWins();
  const total = loadWins() + 1;
  try {
    localStorage.setItem(WINS_KEY, String(total));
  } catch {
    /* A private window, say: the win still counts for the game, just not here. */
  }
  return total;
}
